import React from "react";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";

/**
 * Presentational confirmation dialog for the credit cost of sending a
 * letter. Shows an "insufficient credits" variant when the cost exceeds the
 * available balance. Pure move of the letter-cost AreYouSurePopup that
 * previously lived inline in MailPopup.
 */
function LetterCostDialog({ open, onClose, onConfirm, letterCost, credits }) {
  const insufficient = letterCost > credits;

  return (
    <AreYouSurePopup
      open={open}
      close={onClose}
      title={insufficient ? "Insufficient Credits" : "Confirm Sending"}
      onClick={insufficient ? "" : onConfirm}
      confirmBtn="Send"
      confirmDisabled={insufficient}
      cancelBtn="Cancel"
    >
      {insufficient ? (
        <>
          <p>
            Your balance of <b>{credits} credits</b> is insufficient for
            sending this letter (<b>{letterCost} credits</b>).
          </p>
          <p>
            Please go to <i>Admin &gt; Account &gt; Credits</i> to purchase
            additional credits.
          </p>
        </>
      ) : (
        <>
          {" "}
          <p>
            Sending this letter will cost <b> {letterCost} credits</b>.<br />
            After sending this letter you will have{" "}
            <b>{credits - letterCost} credits</b> left in your balance.
          </p>
          <p>Would you like to send it now? </p>{" "}
        </>
      )}
    </AreYouSurePopup>
  );
}

export default LetterCostDialog;
